var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"modalName":"videoRegisterModal","title":"REJESTR INSPEKCJI WIDEO","buttons":[],"register":_vm.register},on:{"closed":_vm.close}},[_c('VideoInspectionsTable')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9716e200","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/video/modals/VideoRegister.vue
// module id = 2027
// module chunks = 0